<template>
  <main id="resetPassword" class="page __no-header">
    <div class="wrapper">
      <div class="grid">
        <section>
          <router-link tag="a" :to="{ name: 'home' }">
            <img src="img/logos/logo_full@2x.png" alt="">
          </router-link>
        </section>
        <section class="content">
          <div>
            <h4>Recuperação de senha</h4>
            <div v-if="!requested">
              <p>Informe o e-mail da sua conta. Enviaremos um link para você criar uma nova senha.</p>
              <form @submit.prevent="request" class="grid">
                <input v-model="email" type="email" name="email" placeholder="E-mail" required/>
                <button type="submit" :disabled="sending" style="white-space: nowrap">Enviar</button>
              </form>
            </div>
            <transition name="fade">
              <div v-if="requested">
                <p>Se <strong>{{ email }}</strong> estiver cadastrado, você vai receber um e-mail com o link para criar uma nova senha. O link vale por 60 minutos.</p>
                <p>Sua senha atual continua valendo até você definir a nova. Não recebeu? Verifique a caixa de spam.</p>
              </div>
            </transition>
          </div>
          <footer>
            <p>
            &copy; 2019 Todos os direitos reservados. RACE é uma marca registrada pelo INPI.
            </p>
            <nav>
              <ul>
                <router-link tag="li" :to="{ name: 'home' }">INÍCIO</router-link>
                <router-link tag="li" :to="{ name: 'services' }">SERVIÇOS</router-link>
                <router-link tag="li" :to="{ name: 'network' }">REDE</router-link>
                <router-link tag="li" :to="{ name: 'about' }">EMPRESA</router-link>
                <router-link tag="li" :to="{ name: 'contact' }">CONTATO</router-link>
              </ul>
            </nav>
          </footer>
        </section>
      </div>
    </div>
  </main>
</template>

<script>
// Pede o link de recuperacao (password/create). A resposta e a mesma exista ou nao a conta.
export default{
  name: 'resetPasswordRequest',
  data () {
    return {
      email: null,
      requested: false,
      sending: false
    }
  },
  beforeMount () {
    this.email = this.$route.query.email || null
  },
  mounted () {
    if (this.email) this.request()
  },
  methods: {
    request () {
      if (!this.email || this.sending) return
      this.sending = true
      this.$Progress.start()
      this.$http.post(this.$api({ target: 'password/create' }), { email: this.email }).then(() => {
        this.$Progress.finish()
        this.requested = true
      }).catch(err => {
        this.$Progress.fail()
        const data = err.response && err.response.data
        this.$toasted.show((data && data.message) || 'Não foi possível enviar agora. Tente novamente.', { theme: 'primary', position: 'top-center', duration: 6000, type: 'error' })
      }).then(() => {
        this.sending = false
      })
    }
  }
}
</script>
